// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Imagecontainer-main{
    display: grid;
    grid-template-columns: 1fr;
    width: 100%;
    gap: 1vw;
    margin-top: -4vw;
    max-height: 800px;
    height: max-content;
    overflow: hidden;
    padding-left: 10px;
    padding-right: 10px;
}

.Image-main-first{
    width: 100%;
    height: 100%;
    object-fit: fill;

}
.Image-main-second{
    width: 100%;
    height: 100%;
    object-fit: fill;
}
.Image-main-third{
    width: 100%;
    height: 100%;
    object-fit: fill;
    overflow: hidden;

}
.main-image-one{
    border-radius: 2vw;
    box-shadow: 0px 1px 10px 4px rgba(0, 0, 0, 0.06);
    /* height: 800px; */
    width: 100%;
    overflow: hidden;
    margin-top: 4vw;
}
.main-image-second {
    border-radius: 2vw;
    box-shadow: 0px 1px 10px 4px rgba(0, 0, 0, 0.06);
    /* height: 800px; */
    width: 100%;
    overflow: hidden;
}
.main-image-third {
    border-radius: 2vw;
    box-shadow: 0px 1px 10px 4px rgba(0, 0, 0, 0.06);
    /* height: 800px; */
    width: 100%;
    overflow: hidden;
    margin-top: 4vw;
}
.info-box {
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 20px;
    margin: 20px;
    display: grid;
    /* column-gap: 2vw; */
    background-color: white;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    width: 70%;
    z-index: 99;    
}
@media (max-width:'800px'){
    .info-box {
        grid-template-columns: repeat(2, 1fr);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        width: 90%;
        margin:5px;
        z-index: 99;    
    } 
}

.info-box>div {
    margin-bottom: 10px;
    font-size: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: wrap;
}
.content-boxes{
    font-size: 30px;
    font-weight: bold;
}
.content-text{
    font-size: 20px;
    text-align: center;
}
.main-box-con{
    margin-top: -8vw;
    z-index: 99;
}`, "",{"version":3,"sources":["webpack://./src/Aboutus.js/Imagecontainer.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,0BAA0B;IAC1B,WAAW;IACX,QAAQ;IACR,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;;AAEpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;;AAEpB;AACA;IACI,kBAAkB;IAClB,gDAAgD;IAChD,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,gDAAgD;IAChD,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,gDAAgD;IAChD,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,sCAAsC;IACtC,wCAAwC;IACxC,UAAU;IACV,WAAW;AACf;AACA;IACI;QACI,qCAAqC;QACrC,wCAAwC;QACxC,UAAU;QACV,UAAU;QACV,WAAW;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,WAAW;AACf","sourcesContent":[".Imagecontainer-main{\n    display: grid;\n    grid-template-columns: 1fr;\n    width: 100%;\n    gap: 1vw;\n    margin-top: -4vw;\n    max-height: 800px;\n    height: max-content;\n    overflow: hidden;\n    padding-left: 10px;\n    padding-right: 10px;\n}\n\n.Image-main-first{\n    width: 100%;\n    height: 100%;\n    object-fit: fill;\n\n}\n.Image-main-second{\n    width: 100%;\n    height: 100%;\n    object-fit: fill;\n}\n.Image-main-third{\n    width: 100%;\n    height: 100%;\n    object-fit: fill;\n    overflow: hidden;\n\n}\n.main-image-one{\n    border-radius: 2vw;\n    box-shadow: 0px 1px 10px 4px rgba(0, 0, 0, 0.06);\n    /* height: 800px; */\n    width: 100%;\n    overflow: hidden;\n    margin-top: 4vw;\n}\n.main-image-second {\n    border-radius: 2vw;\n    box-shadow: 0px 1px 10px 4px rgba(0, 0, 0, 0.06);\n    /* height: 800px; */\n    width: 100%;\n    overflow: hidden;\n}\n.main-image-third {\n    border-radius: 2vw;\n    box-shadow: 0px 1px 10px 4px rgba(0, 0, 0, 0.06);\n    /* height: 800px; */\n    width: 100%;\n    overflow: hidden;\n    margin-top: 4vw;\n}\n.info-box {\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    padding: 20px;\n    margin: 20px;\n    display: grid;\n    /* column-gap: 2vw; */\n    background-color: white;\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    width: 70%;\n    z-index: 99;    \n}\n@media (max-width:'800px'){\n    .info-box {\n        grid-template-columns: repeat(2, 1fr);\n        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n        width: 90%;\n        margin:5px;\n        z-index: 99;    \n    } \n}\n\n.info-box>div {\n    margin-bottom: 10px;\n    font-size: 16px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    flex-wrap: wrap;\n}\n.content-boxes{\n    font-size: 30px;\n    font-weight: bold;\n}\n.content-text{\n    font-size: 20px;\n    text-align: center;\n}\n.main-box-con{\n    margin-top: -8vw;\n    z-index: 99;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
